import { render, staticRenderFns } from "./Termos.vue?vue&type=template&id=106ceb66&"
import script from "./Termos.vue?vue&type=script&lang=js&"
export * from "./Termos.vue?vue&type=script&lang=js&"
import style0 from "./Termos.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports